const chart = {
  primary: {
    color: 'secondary',
    '&:active, &:focus': {
      color: 'indigo.90',
    },
    '&:hover': {
      color: 'indigo.90',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'orange.60',
    },
    '&:hover': {
      color: 'orange.60',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  primaryAlternate: {
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'secondary',
    },
    '&:hover': {
      color: 'secondary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondaryAlternate: {
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'orange.60',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'secondary',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'secondary',
      textDecoration: 'none',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'primary',
      },
      '&:active, &:focus': {
        color: 'primary',
      },
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  languageSwitcher: {
    textDecoration: 'none',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primaryText',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primaryText',
      textDecoration: 'none',
    },
    '&[aria-disabled="true"]': {
      color: 'primaryText',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  quoteLink: {
    color: 'coolGrey.100',
    '&:active, &:focus': {
      color: 'orange.60',
    },
    '&:hover': {
      color: 'orange.60',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  hasDarkBackground: {
    color: 'white',
    '&:active, &:focus': {
      color: 'white',
    },
    '&:hover': {
      color: 'coolGrey.20',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
};

const co = {
  primary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'blue.90',
    },
    '&:hover': {
      color: 'blue.90',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100',
    },
    '&:hover': {
      color: 'coolGrey.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100',
    },
    '&:hover': {
      color: 'coolGrey.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'blue.90',
      },
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'blue.90',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'blue.90',
      },
      '&:active, &:focus': {
        color: 'blue.90',
      },
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  languageSwitcher: {
    textDecoration: 'none',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&[aria-disabled="true"]': {
      color: 'primaryText',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  quoteLink: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'primary',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'primary',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  hasDarkBackground: {
    color: 'white',
    '&:active, &:focus': {
      color: 'white',
    },
    '&:hover': {
      color: 'coolGrey.20',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
};

const edu = {
  primary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'indigo.80',
    },
    '&:hover': {
      color: 'indigo.80',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100',
    },
    '&:hover': {
      color: 'coolGrey.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100',
    },
    '&:hover': {
      color: 'coolGrey.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'primary',
      },
      '&:active, &:focus': {
        color: 'primary',
      },
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  languageSwitcher: {
    textDecoration: 'none',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&[aria-disabled="true"]': {
      color: 'primaryText',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  quoteLink: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100',
    },
    '&:hover': {
      color: 'coolGrey.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  hasDarkBackground: {
    color: 'white',
    '&:active, &:focus': {
      color: 'white',
    },
    '&:hover': {
      color: 'coolGrey.20',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
};

const scale = {
  primary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'primaryAccent',
    },
    '&:hover': {
      color: 'primaryAccent',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100',
    },
    '&:hover': {
      color: 'indigo.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primaryAccent',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.90',
    },
    '&:hover': {
      color: 'indigo.90',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primaryAccent',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'primary',
      },
      '&:active, &:focus': {
        color: 'primary',
      },
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  languageSwitcher: {
    textDecoration: 'none',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&[aria-disabled="true"]': {
      color: 'primaryText',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  quoteLink: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100',
    },
    '&:hover': {
      color: 'indigo.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  hasDarkBackground: {
    color: 'white',
    '&:active, &:focus': {
      color: 'white',
    },
    '&:hover': {
      color: 'coolGrey.20',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
};

const spark = {
  primary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'red.80',
    },
    '&:hover': {
      color: 'red.80',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100',
    },
    '&:hover': {
      color: 'indigo.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
    },
    '&:hover': {
      color: 'primary',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.90',
    },
    '&:hover': {
      color: 'indigo.90',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
      textDecoration: 'none',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
    },
  },
  subNavLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none',
      '& > span, & > p': {
        color: 'primary',
      },
    },
    '& > p': {
      '&:hover': {
        color: 'primary',
      },
      '&:active, &:focus': {
        color: 'primary',
      },
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  languageSwitcher: {
    textDecoration: 'none',
    color: 'primaryText',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'underline',
    },
    '&[aria-disabled="true"]': {
      color: 'primaryText',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  quoteLink: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100',
    },
    '&:hover': {
      color: 'indigo.100',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  hasDarkBackground: {
    color: 'white',
    '&:active, &:focus': {
      color: 'white',
    },
    '&:hover': {
      color: 'coolGrey.20',
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
};

const links = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark,
  },
};

export type LinkVariantsType =
  | 'primary'
  | 'secondary'
  | 'primaryAlternate'
  | 'secondaryAlternate'
  | 'navLink'
  | 'subNavLink'
  | 'languageSwitcher'
  | 'quoteLink'
  | 'hasDarkBackground';

export const linkVariants = Object.keys(chart) as LinkVariantsType[];

export default links;
